import React, { useState } from 'react';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import styles from './blog-grid.module.css';
import { ResourceGrid as ResourceGridProp, Taxonomy } from '../../typescript/component';
import Button from '../ui/button';
import BlogCard from '../cards/blog-card';
import { useRouter } from 'next/router';

export default function BlogGrid({
  resource_grid,
}: {
  resource_grid: ResourceGridProp;
  taxonomies?: Taxonomy[];
}) {
  const { locale } = useRouter();
  const [currentLanguage, setCurrentLanguage] = useState(locale || 'en-us');

  return (
    <div className={styles.blogGridContainer}>
      {(resource_grid.eyebrow || resource_grid.title) && (
        <div className={styles.blogGridHeading}>
          <h4 className={styles.blogGridEyebrow}>{resource_grid.eyebrow}</h4>
          <h3 className={styles.blogGridTitle}>{resource_grid.title}</h3>
        </div>
      )}
      <div className={styles.blogGrid}>
        {resource_grid.featured_resources && resource_grid.featured_resources.length > 0 && (
          <section className={styles.cards}>
            {resource_grid.featured_resources.slice(0, 3).map((item, index) => (
              <div key={index} className={styles.slide}>
                <BlogCard
                  key={`BlogCard-${currentLanguage}`}
                  blog_post={item}
                  component_type={resource_grid.component_type}
                />
              </div>
            ))}
          </section>
        )}
        {resource_grid.cta && resource_grid.cta.title && resource_grid.cta.url && (
          <Button
            text={resource_grid.cta.title}
            showIcon
            propWidth="250px"
            propBackgroundColor="var(--primary-500)"
            propHoverBackgroundColor="transparent"
            propTextColor="var(--white)"
            link={resource_grid.cta.url}
          />
        )}
      </div>
    </div>
  );
}
